import { H2, P } from "../../../components/text/TextComponents";
import { css } from "emotion";
import Image from "../../../components/Image";
import { Button } from "../../../components/global";
import ColorServices from "../../../services/ColorServices";

const bookASessionWrapper = css({
  backgroundColor: ColorServices.getColor("purpleMid"),
  padding: "68px 14px",
  textAlign: "center",
  "@media(max-width: 768px)": {
    padding: "40px 14px"
  },
  h2: {
    color: "white"
  },
  p: {
    color: "white",
    maxWidth: 600
  }
});
const questionMark = require("../../../assets/humanitixFaces/question.svg");

const BookASession = ({}) => {
  return (
    <div className={bookASessionWrapper}>
      <Image
        imageURL={questionMark}
        alt=""
        styleSheet={css({
          width: 60,
          height: 60
        })}
      />

      <H2 marginBottom={12} marginBottomMobile={8}>
        Would you like a hand getting started?
      </H2>
      <P marginBottom={24} marginBottomMobile={16}>
        Book a session with an Event Specialist to answer any tricky question
        and get your event up and running today.
      </P>
      <Button
        size="large"
        type="secondary"
        ariaLabel="Book a session"
        link="https://meetings.hubspot.com/adam-long1/humanitix-demo-see-how-to-give-your-events-impact"
      >
        Book a session
      </Button>
    </div>
  );
};

export default BookASession;
